import { render } from "./EstruturaModal.vue?vue&type=template&id=e777283a&scoped=true"
import script from "./EstruturaModal.vue?vue&type=script&lang=js"
export * from "./EstruturaModal.vue?vue&type=script&lang=js"

import "./EstruturaModal.vue?vue&type=style&index=0&id=e777283a&scoped=true&lang=css"

import exportComponent from "G:\\Centrion\\projetos\\vue\\sisDemode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e777283a"]])

export default __exports__